import React from "react";
import Nav from "../components/Nav";
import {
  QuestionCOntainer,
  QuestionnaireTitle,
  QuestionnaireDetail,
  QuestionnaireDetailContainer,
  StartBtn,
  ButtonBox,
} from "../components/QuestionaireStyledComponents/Questionnaire";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { pageTransition, transit } from "../animate";
import Footer from "../components/Footer";

const StartQuestionnaire = () => {
  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={pageTransition}
      transition={transit}
    >
      <Nav />
      <QuestionCOntainer>
        <QuestionnaireTitle>
          Welcome to our pairing questionnaire
        </QuestionnaireTitle>
        <QuestionnaireDetailContainer>
          <QuestionnaireDetail>
            This will help us pair you with the right dog that fits your
            lifestyle. We will provide you with a detailed information guide as
            well as resources on where to adopt your dog match.
          </QuestionnaireDetail>
        </QuestionnaireDetailContainer>
      </QuestionCOntainer>
      <ButtonBox>
        <StartBtn
          variant="contained"
          disableElevation
          component={Link}
          to="/questionnaire"
        >
          Let's Start
        </StartBtn>
      </ButtonBox>
      <Footer />
    </motion.div>
  );
};

export default StartQuestionnaire;
